export { default as capitalizeFirstLetter } from './capitalizeFirstLetter';
